import create from 'zustand';

export const [useStore, api]: any = create(set => ({

    companyBank: null,
    consigneeData: null,

    manufactureDetailData: null,

    pfiData: null,
    psiData: null,
    packingList: null,
    purchaseOrder: null,
    commercialInvoice: null,
    finalPackingList: null,
    
    saveInvoice: null,
}));